import { ApiError, errorMessage } from '../../api';

/**
 * Turn a failed sign-up / add-user call into what the form shows:
 *  - 409 "Username is already taken" belongs under the username;
 *  - a 400's `errors` lines each start with the field they are about ("password: must be at least 8 characters"):
 *    those go under that field, and any other line goes into one general message;
 *  - anything else (offline, 403 "Registration is switched off", ...) is a general message.
 */
export function formErrorsFrom(err: unknown, fields: readonly string[]): { fieldErrors: Record<string, string>; general: string } {
  const fieldErrors: Record<string, string> = {};
  if (err instanceof ApiError && err.status === 409) {
    fieldErrors.username = err.message;
    return { fieldErrors, general: '' };
  }
  if (err instanceof ApiError && err.status === 400 && err.details.length) {
    const general: string[] = [];
    (err.details as string[]).forEach((line) => {
      const m = /^(\w+):\s*(.+)$/.exec(line);
      if (m && fields.includes(m[1]) && !fieldErrors[m[1]]) fieldErrors[m[1]] = m[2];
      else general.push(line);
    });
    return { fieldErrors, general: general.length ? `${err.message}: ${general.join('; ')}` : '' };
  }
  return { fieldErrors, general: errorMessage(err) };
}
